import React, { FC } from "react";
import {
  CategorizationSetType,
  CategorizationWithConfig,
} from "../../../../configMap/interfaces/category";
import FixedCategorizationWrapper from "./FixedCategorizationWrapper";
import DynamicCategorizationWrapper from "./DynamicCategorizationWrapper";
import DerivedCategorizationWrapper from "./DerivedCategorizationWrapper";

type Props = {
  disabled: boolean;
  categorizationWithConfig: CategorizationWithConfig;
  index: number;
  groupBlockId?: string;
};

const CategorizationSwitch: FC<Props> = (props) => {
  const { categorizationWithConfig } = props;
  const { setType } = categorizationWithConfig.categorization;

  switch (setType) {
    case CategorizationSetType.FIXED:
      return <FixedCategorizationWrapper {...props} />;
    case CategorizationSetType.DERIVED:
      return <DerivedCategorizationWrapper {...props} />;
    default:
      return <DynamicCategorizationWrapper {...props} />;
  }
};

export default CategorizationSwitch;
